import React from "react";
import useAddtoCart from "../../../../../Redux/use-addtocart";
import { useState, useCallback, useEffect } from "react";
import { useSelector } from "react-redux";
const vendor = "37cfbaa0cdd335e81abd4aba05c5e254";
const AddToCartBTN = ({ item }) => {
  //---------------REDUX------------------
  const cart = useSelector(
    (state) => state.user.cart?.filter((c) => c.vendorId === vendor)?.[0]?.cart
  );

  const { addItem, removeItem } = useAddtoCart();

  const [newItem, setnewItem] = useState(true);

  const [quantity, setquantity] = useState(null);

  const newItemHandler = useCallback(() => {
    let ProductIndex = -1;

    if (cart?.length > 0) {
      ProductIndex = cart?.findIndex(
        (element) => element.pName === item.newProductName
      );
    }

    if (ProductIndex === -1) {
      setnewItem(true);
      return;
    }

    setquantity(cart[ProductIndex].qty);
    setnewItem(false);
  }, [item, cart]);

  const quantityHandler = (type) => {
    switch (type) {
      case "increase":
        addItem(item);
        break;
      case "decrease":
        removeItem(item);
        break;
    }
  };

  useEffect(() => {
    newItemHandler();
  }, [newItemHandler, cart]);

  /* ------------------JSX--------------------- */

  return (
    <>
      {/* ------------------single button-------item not in cart-------------- */}
      {newItem && (
        <a
          onClick={(e) => {
            e.preventDefault();
            addItem(item);
          }}
          href="#"
          className="add-cart-link"
        >
          <i className="bi bi-plus"></i>
        </a>
      )}

      {/* --------------double button------item already in cart--------------- */}
      {!newItem && (
        <div className="add-cart-num">
          <i
            onClick={() => quantityHandler("decrease")}
            className="bi bi-dash"
          ></i>
          <div>{quantity}</div>
          <i
            onClick={() => quantityHandler("increase")}
            className="bi bi-plus"
          ></i>
        </div>
      )}
    </>
  );
};

export default AddToCartBTN;
